import { useContext, useEffect, useState } from 'react';
import UserContext from 'src/context/UserContext';
import { Role } from 'src/Role';
import { AuthService } from 'src/services/AuthService';
import { getShopLogoUrl } from 'src/utils/shopLogo';

export function useCustomerShopBranding() {
  const [user] = useContext(UserContext);
  const [shopName, setShopName] = useState('');
  const [shopLogoUrl, setShopLogoUrl] = useState<string | undefined>();

  useEffect(() => {
    if (user?.role !== Role.CUSTOMER) {
      setShopName('');
      setShopLogoUrl(undefined);
      return;
    }

    const populated = user.populatedShop;
    if (populated?.shopName) {
      setShopName(populated.shopName);
    }
    const populatedLogo =
      getShopLogoUrl((populated as { profileImageId?: unknown })?.profileImageId) ||
      getShopLogoUrl(populated?.profileImage);
    if (populatedLogo) {
      setShopLogoUrl(populatedLogo);
    }

    const shopId = user.shopId;
    if (!shopId) return;

    AuthService.getShopDashboardByShopId(
      shopId,
      user.branchId || 'Default_Branch'
    )
      .then((res) => {
        if (!res?.data) return;
        setShopName(res.data.shopName || populated?.shopName || '');
        setShopLogoUrl(
          getShopLogoUrl(res.data.profileImageId) ||
            getShopLogoUrl(res.data.profileImage) ||
            populatedLogo
        );
      })
      .catch(() => {
        // Keep populatedShop values if dashboard fetch fails
      });
  }, [user]);

  return {
    isCustomer: user?.role === Role.CUSTOMER,
    shopName,
    shopLogoUrl,
    shopInitial:
      shopName?.charAt(0)?.toUpperCase() ||
      user?.name?.charAt(0)?.toUpperCase() ||
      'S'
  };
}
